<template>
  <div class="container">
    <header class="jumbotron">
      <h4 style="text-align: center;">Forgot Password?</h4>
      <h6 style="text-align: center;">Call Jake</h6>
    </header>
  </div>
</template>

<script>

export default {
  name: 'ForgotPassword',
};
</script>
